const GOOGLE_CLIENT_ID = "724405183597-qqmqnhdi2k7qd5m0u2de1b069etv333j.apps.googleusercontent.com";

/**
 * Decodes JWT response from Google API
 * @param {string} token - JWT token from Google
 * @returns {Object} Decoded JWT payload
 */
export function decodeJwtResponseFromGoogleAPI(token) {
    let base64Url = token.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload =
        decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' +
                c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    return JSON.parse(jsonPayload)
}

/**
 * Renders Google Sign-In button in the specified element
 * @param {string} elementId - ID of the element where the button should be rendered
 * @param {Function} onSuccessCallback - Callback function to call after successful login
 */
export function renderGoogleLoginButton(elementId, onSuccessCallback) {
    /*** Handle auth */
    try {
        window.google.accounts.id.initialize({
            client_id: GOOGLE_CLIENT_ID,
            callback: onSuccessCallback,
        });

        window.google.accounts.id.renderButton(document.getElementById(elementId), {
            theme: "outline",
            size: "large",
            text: "sign_in",
        });

        window.google.accounts.id.prompt();
    } catch (e) {
        console.log("Error", e);
        // TODO: Send errors to cloud
    }
    /*** End Auth */
}

/**
 * Handles successful Google login
 * @param {Object} response - Response from Google Sign-In
 * @param {Function} setCookie - Function to set cookies
 * @param {Function} onAfterLogin - Callback to execute after setting cookies
 */
export function handleGoogleLoginSuccess(response, setCookie, onAfterLogin) {
    const loginInfo = decodeJwtResponseFromGoogleAPI(response['credential']);
    setCookie('given_name', loginInfo['given_name'], { path: '/' });
    setCookie('email', loginInfo['email'], { path: '/' });
    setCookie('userid', loginInfo['sub'], { path: '/' });
    setCookie('picture', loginInfo['picture'], { path: '/' });
    setCookie('credential', response['credential'], { path: '/' });

    console.log(response);
    console.log('LoginInfo: ' + JSON.stringify(loginInfo));

    if (onAfterLogin) {
        onAfterLogin();
    }
}

/**
 * Logs out the user by removing all authentication cookies
 * @param {Function} removeCookie - Function to remove cookies
 * @param {Function} renderLoginButton - Function to re-render login button after logout
 */
export function logout(removeCookie, renderLoginButton) {
    console.log('Removing cookies');
    removeCookie('given_name', { path: '/' });
    removeCookie('userid', { path: '/' });
    removeCookie('email', { path: '/' });
    removeCookie('picture', { path: '/' });
    removeCookie('credential', { path: '/' });

    if (renderLoginButton) {
        setTimeout(renderLoginButton);
    }
}
